import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';

import { ApplicationsComponent } from './applications.component';

const routes: Routes = [
    {
        path: '',
        component: ApplicationsComponent
    }
]


@NgModule({ imports: [RouterModule.forChild(routes)] })
export class ApplicationsRoutingModule {
}